export const nfReport = {
	label: "Facturas fiscales de compra",
	columns: {
		name: "Número de la factura",
		date: "Fecha de importación",
		emission: "Fecha de emisión",
		value: "Valor",
	},
	productColumns: {
		name: "Productos",
		quantity: "Cantidad",
		unit: "Unidad",
		unitValue: "Valor unitario",
		total: "Valor total",
	},
	notAssociatedProduct: "(Producto no asociado)",
	empty: "Sin productos",
};
